module.exports = __webpack_public_path__ + "img/list.67549be9.svg";